import React from "react";
import List from "@material-ui/core/List";
import ListItemText from "@material-ui/core/ListItemText";
import { ListItem } from "@material-ui/core";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import Collapse from "@material-ui/core/Collapse";
import { makeStyles } from "@material-ui/core/styles";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import { useSelector } from "react-redux";
import Slider from "@material-ui/core/Slider";
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/styles";
import { isEqual } from "../helper";

const CustomSlider = withStyles({
  valueLabel: {
    top: -22,
    left: -11,
    fontSize: 15,
    "& *": {
      background: "transparent",
      color: "#000",
    },
  },
  thumb: {
    height: 14,
    width: 14,
    backgroundColor: "#fff",
    border: "2px solid currentColor",
    "&:focus, &:hover, &$active": {
      boxShadow: "inherit",
    },
  },
  markLabel: {
    fontWeight: "bold",
    fontSize: 15,
    "&:focus, &:hover, &$active": {
      boxShadow: "inherit",
    },
  },
})(Slider);

const useStyles = makeStyles((theme) => ({
  nested: {
    paddingLeft: theme.spacing(4),
  },
}));

const GenericFilter = ({
  type,
  name,
  options,
  id,
  parentId,
  ar_name,
  filtersToApply,
  setFiltersToApply,
}) => {
  const classes = useStyles();

  //REDUX
  const themeColor = useSelector((state) => state.store.store.settings?.dark);
  const language = useSelector((state) => state.store.language);

  //GETS SELECTED FILTERS FROM REDUX AND SORT THEM
  const selectedFiltersOptions = useSelector((state) =>
    state.productFilter.filtersSelected
      .filter((filter) => filter.parent_id === id)
      .map((filter) => {
        return {
          id: filter.value,
          name: filter.filterOptionName,
        };
      })
      .sort((a, b) => (+a.name > +b.name ? 1 : +b.name > +a.name ? -1 : 0))
  );

  //GETS ALL FILTER OPTIONS AND SORT THEM
  const optionsItems = options
    .map((option) => {
      return {
        id: option.id,
        name: option.name,
        ar_name: option.ar_name,
      };
    })
    .sort((a, b) => (+a.name > +b.name ? 1 : +b.name > +a.name ? -1 : 0));

  //CHECKS IF THERE IS OPTIONS SELECTED FOR THIS FILTER
  //IF YES, THE DEFAULT VALUE IS ARRAY OF selectedFiltersOptions FIRST AND LAST ELEMENTS
  //IF NO, THE DEFAULT VALUE IS ARRAY OF optionsItems FIRST AND LAST ELEMENTS
  const defaultValue =
    selectedFiltersOptions.length > 0
      ? [
          +selectedFiltersOptions[0].name,
          +selectedFiltersOptions[selectedFiltersOptions.length - 1].name,
        ]
      : [+optionsItems[0].name, +optionsItems[optionsItems?.length - 1].name];

  //COMPONENT STATE
  const [filterRange, setFilterRange] = React.useState(defaultValue);
  const [open, setOpen] = React.useState(false);

  //COMPONENT FUNCTIONS
  const handleClick = () => {
    setOpen(!open);
  };

  const isFilterOptionSelected = (value) => {
    return filtersToApply.some((filter) => filter.value === value);
  };

  const isFilterSelected = () => {
    return filtersToApply.some((filter) => filter.parent_id === id);
  };

  //HANDLES THE LIST FILTER
  const handleSelectFilter = (nameToDisplay, nameToDisplayArabic, value) => {
    if (filtersToApply.some((filter) => filter.value === value)) {
      setFiltersToApply(filtersToApply.filter((item) => item.value !== value));
    } else {
      setFiltersToApply([
        ...filtersToApply,
        {
          filterName: name,
          filterArName: ar_name,
          filterOptionArName: nameToDisplayArabic,
          filterOptionName:
            nameToDisplay.charAt(0).toUpperCase() + nameToDisplay.slice(1),
          value: value,
          parent_id: id,
          type: type,
        },
      ]);
    }
  };

  //LOGIC FOR RANGE SLIDER

  //APPLY THE FILTER FOR RANGE SLIDER
  const handleApplyFilter = () => {
    setFiltersToApply([
      ...filtersToApply.filter((filter) => filter.parent_id !== id),
      ...getRange(),
    ]);
    setOpen(false);
  };

  //CLEAR THE FILTER FOR RANGE SLIDER
  const handleClearFilter = () => {
    setFiltersToApply([
      ...filtersToApply.filter((filter) => filter.parent_id !== id),
    ]);
    setOpen(false);
    setFilterRange([
      +optionsItems[0].name,
      +optionsItems[optionsItems?.length - 1].name,
    ]);
  };

  //return options in hash map of key value pairs
  //FOR THE RANGE MARKS
  const getOptions = () => {
    let optionsMap = [];
    options
      .sort((a, b) => (+a.name > +b.name ? 1 : +b.name > +a.name ? -1 : 0))
      .forEach((option, index) => {
        optionsMap.push({
          value: +option.name,
          label:
            index === 0 || index === options.length - 1 ? +option.name : "",
        });
      });
    return optionsMap;
  };

  //return all numbers between two numbers in optionItems
  const getRange = () => {
    let range = [];
    options.forEach((item) => {
      if (+item.name >= filterRange[0] && +item.name <= filterRange[1]) {
        range.push({
          filterName: name,
          filterArName: ar_name,
          filterOptionName:
            item.name.charAt(0).toUpperCase() + item.name.slice(1),
          value: item.id,
          filterOptionArName: item.ar_name,
          parent_id: id,
          type: type,
        });
      }
    });
    return range;
  };

  return (
    <>
      <ListItem
        button
        onClick={handleClick}
        style={{
          paddingLeft: language === "arabic" ? "" : 0,
          paddingRight: language === "arabic" ? 0 : "",
          marginTop: 15,
          direction: language === "arabic" ? "rtl" : "ltr",
        }}
      >
        <div
          style={{
            flex: 1,
            display: "flex",
            alignItems: "center",
          }}
        >
          <div
            style={{
              height: "26px",
              width: "6px",
              backgroundColor: isFilterSelected() ? themeColor : "transparent",
            }}
          ></div>
          <span
            style={{
              flex: 1,
              marginLeft: language === "arabic" ? 0 : 16,
              marginRight: language === "arabic" ? 16 : 0,
              fontWeight: "bold",
              fontSize: "15px",
              textAlign: language === "arabic" ? "right" : "left",
            }}
          >
            {language === "arabic"
              ? ar_name
              : name.charAt(0).toUpperCase() + name.slice(1)}
          </span>
          {isFilterSelected() && (
            <FiberManualRecordIcon
              style={{
                fontSize: 14,
                color: themeColor,
                marginRight: language === "arabic" ? 0 : 10,
                marginLeft: language === "arabic" ? 10 : 0,
              }}
            />
          )}
        </div>
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        {type === "text" ? (
          <List component="div" disablePadding>
            {options?.map((item) => (
              <ListItem
                style={{
                  direction: language === "arabic" ? "rtl" : "ltr",
                  paddingLeft: language === "arabic" ? "" : 0,
                  paddingRight: language === "arabic" ? 0 : "",
                  textAlign: language === "arabic" ? "right" : "left",
                }}
                button
                className={classes.nested}
                onClick={() =>
                  handleSelectFilter(item.name, item.ar_name, item.id)
                }
              >
                <div
                  style={{
                    height: "26px",
                    width: "6px",
                    backgroundColor: isFilterOptionSelected(item.id)
                      ? themeColor
                      : "transparent",
                  }}
                ></div>
                <ListItemText
                  style={{
                    marginLeft: language === "arabic" ? 0 : 20,
                    marginRight: language === "arabic" ? 20 : 0,
                    fontSize: "15px",
                  }}
                  primary={
                    language === "arabic"
                      ? item.ar_name
                      : item.name.charAt(0).toUpperCase() + item.name.slice(1)
                  }
                />
              </ListItem>
            ))}
          </List>
        ) : (
          <>
            <ListItem>
              <div
                style={{
                  width: "100%",
                  padding: "0 16px 0 16px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                }}
              >
                <CustomSlider
                  min={+optionsItems[0].name}
                  max={+optionsItems[optionsItems?.length - 1].name}
                  value={filterRange}
                  onChange={(event, value) => {
                    setFilterRange(value);
                  }}
                  valueLabelDisplay={
                    isEqual(filterRange, [
                      +optionsItems[0].name,
                      +optionsItems[optionsItems?.length - 1].name,
                    ])
                      ? "off"
                      : "on"
                  }
                  range
                  step={null}
                  marks={getOptions()}
                />
              </div>
            </ListItem>
            <ListItem>
              <div
                style={{
                  width: "100%",
                  padding: "0 8px",
                  display: "flex",
                  justifyContent: "flex-end",
                  flexDirection: language === "arabic" ? "row-reverse" : "row",
                }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleApplyFilter}
                  size={"small"}
                  style={{
                    marginLeft: language === "arabic" ? 0 : 25,
                    marginRight: language === "arabic" ? 25 : 0,
                    marginTop: 5,
                    textTransform: "none",
                    boxShadow: "none",
                  }}
                >
                  {language === "arabic" ? "تطبيق" : "Apply"}
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleClearFilter}
                  size={"small"}
                  style={{
                    marginLeft: language === "arabic" ? 0 : 10,
                    marginRight: language === "arabic" ? 10 : 0,
                    marginTop: 5,
                    color: "rgb(51, 51, 51)",
                    backgroundColor: "rgb(255, 255, 255)",
                    border: " 1px solid rgb(222, 222, 222)",
                    textTransform: "none",
                    boxShadow: "none",
                  }}
                >
                  {language === "arabic" ? "مسح" : "Clear"}
                </Button>
              </div>
            </ListItem>
          </>
        )}
      </Collapse>
    </>
  );
};

export default GenericFilter;
